"use strict";

exports.__esModule = true;
exports.FlexyUI = exports.config = void 0;

var _baseCss = _interopRequireDefault(require("../../../styles/resets/base.css.js"));

var _forEach = _interopRequireDefault(require("../../../styles/utilities/forEach"));

var _index = _interopRequireDefault(require("../../styled/index"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var config = {
  gapSize: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20
  }
};
exports.config = config;
var FlexyUI =
/*#__PURE__*/
(0, _index.default)('div', {
  target: "e73ym070"
})(_baseCss.default, " align-items:center;display:flex;justify-content:space-between;&.is-align-top{align-items:flex-start;}&.is-align-middle{align-items:center;}&.is-align-bottom{align-items:flex-end;}&.is-align-stretch{align-items:stretch;}&.is-just-default{justify-content:space-between;}&.is-just-left{justify-content:flex-start;}&.is-just-center{justify-content:center;}&.is-just-right{justify-content:flex-end;}", makeGapStyles(), ";");
exports.FlexyUI = FlexyUI;

function makeGapStyles() {
  return (0, _forEach.default)(config.gapSize, function (size, value) {
    return "\n    &.is-gap-" + size + " {\n      > * {\n        margin-left: " + value + "px;\n\n        &:first-child {\n          margin-left: 0;\n        }\n      }\n    }\n  ";
  });
}